<div [ngClass]="{'page-spinner-wrap' : placement === 'full-page'}">
    <div class="base-spinner" [ngClass]="variant" [ngStyle]="{height: size, width: size, borderColor: barColor, borderTopColor: color}"></div>
</div>